import list from 'src/modules/quizResult/list/quizResultReducers';
import view from 'src/modules/quizResult/view/quizResultViewReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  view,
});
